import { ANIMATION_TIMINGS } from './ANIMATION_TIMINGS';
import { useStaggerAnimation } from './useStaggerAnimation';

export const useFullScreenInputStaggerAnimation = (
	onStaggeringAnimationTimeout?: () => void,
): {
	shouldAnimate: boolean;
	resetAnimation: () => void;
} => {
	return useStaggerAnimation({
		delay: ANIMATION_TIMINGS.fullscreenInput,
		onStaggeringAnimationTimeout,
	});
};
